export default __webpack_public_path__ + "static/media/rightCheck.f25dd812.svg";